import { useState, useCallback } from 'react';
import type { Payment } from '../types';
import { getErrorMessage } from '../utils/errors';
import { fetchOrderPaymentsFromDb } from '../services/orderService';
import { fetchPaymentHistoryFromDb, type PaymentHistoryEntry } from '../services/paymentsHistoryService';

interface UsePaymentsReturn {
    payments:       Payment[];
    paymentHistory: PaymentHistoryEntry[];
    fetchPayments:  (orderId: string) => Promise<void>;
}

export function usePayments(): UsePaymentsReturn {
    const [payments,       setPayments]       = useState<Payment[]>([]);
    const [paymentHistory, setPaymentHistory] = useState<PaymentHistoryEntry[]>([]);

    const fetchPayments = useCallback(async (orderId: string) => {
        try {
            const [data, history] = await Promise.all([
                fetchOrderPaymentsFromDb(orderId),
                fetchPaymentHistoryFromDb(orderId),
            ]);

            console.log('payments:', data);
            console.log('paymentHistory:', history);

            setPayments(data);
            setPaymentHistory(history);
        } catch (err) {
            console.error('usePayments.fetchPayments:', getErrorMessage(err, 'Failed to fetch payments'));
        }
    }, []);



    return { payments, paymentHistory, fetchPayments };
}